import { API } from "../actions/API";

export const getAndSetData = async (options = {}, setter, dispatch) => {
  const { endpoint, method, data, sortKey } = options;

  const result = await dispatch(API(endpoint, method, data));
  if (sortKey) {
    result.sort((a, b) => a[sortKey].localeCompare(b[sortKey]));
  }
  setter(result);

  return null;
};
